import React from 'react';

export const useFocusAfterSave = (saving: boolean): ((target: React.RefObject<HTMLElement>) => void) => {
  const pending = React.useRef<React.RefObject<HTMLElement> | null>(null);

  React.useEffect(() => {
    if (saving || !pending.current) return;
    pending.current.current?.focus();
    pending.current = null;
  }, [saving]);

  return (target) => {
    pending.current = target;
  };
};
